import { render, staticRenderFns } from "./ChallengeDetailModal.vue?vue&type=template&id=16370652&scoped=true"
import script from "./ChallengeDetailModal.vue?vue&type=script&lang=js"
export * from "./ChallengeDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ChallengeDetailModal.vue?vue&type=style&index=0&id=16370652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16370652",
  null
  
)

export default component.exports